import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../rl-common/dialogs/core/dialog.service';
import { RequestService } from '../core/request.service';
import { citationRequest } from '../shared/citationRequest';

@Component({
  selector: 'rl-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {

  @Input() request : citationRequest; 

  constructor( private dialog : DialogService, private translate : TranslateService, private requestService : RequestService) { }

  ngOnInit(): void {
  }

  deleteRequest(index){
    let msg = this.translate.instant('request.delete.action.areYouSure');

    this.dialog.openDeleteDialog(msg, () => {
      
      if(this.request.type == 'FulRequest'){
        this.requestService.deleteDigitizationRequest(this.request).subscribe(() =>console.log("fetch"));
      } else {
        this.requestService.deleteCopyrightClearance(this.request).subscribe(() =>console.log("fetch"));
      }
    });
  }


}
